module.exports = (__parcel__import__("8L0Sg")).then(() => parcelRequire('4MKVl'));